import { render, staticRenderFns } from "./ChallengesArchive.vue?vue&type=template&id=7c49ab73"
import script from "./ChallengesArchive.vue?vue&type=script&lang=js"
export * from "./ChallengesArchive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports